'use client';

import { useTranslation } from '@/contexts/dictionaryContext';
import { PropsWithChildren } from 'react';
import ReviewsSectionRating from './Rating';

type Props = {
  className?: string;
  countReviews: number;
  avgReviews: number;
} & PropsWithChildren;

export default function ReviewsSectionHeader({
  className,
  countReviews,
  children,
  avgReviews,
}: Props) {
  const { village } = useTranslation();

  const title = village.reviewsSection.title ?? 'Reviews from our guests';

  return (
    <div id="reviews-ref" className={className}>
      <div className="flex-[0_0_auto] w-full desktop:w-2/3">
        <h2 className="mb-2 text-title font-title">{`${countReviews} ${title}`}</h2>
        <div className="flex items-center">
          <ReviewsSectionRating
            averageScore={avgReviews}
            className="mr-2 mb-2 text-primary"
          />
          <h2 className="mb-2 text-4xl font-semibold">
            {Math.round(avgReviews * 10) / 10}
          </h2>
          <h2 className="text-body font-semibold">/5</h2>
        </div>
      </div>
      {children}
    </div>
  );
}
